import { formatAmount } from '@/util/helpers'
import subscriptionStatuses from '@/util/subscriptionStatuses'
import Pagination from '@/util/pagination'

export default function () {
  return {
    formatAmount,
    subscriptionStatuses,
    subscriptions: [],
    planSearchQuery: '',
    plansList: [],
    loadingPlans: false,
    filters: {
      status: [],
      plan: [],
      'teacher.email': null,
      'discountCoupon.code': null,
    },
    pagination: new Pagination(),
  }
}
